import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import login from '@/components/security/login.vue';
import forgotPassword from '@/components/security/forgotPassword.vue';
import Test from '@/components/chartTest.vue';
import resetPassword from '@/components/security/resetPassword.vue';
import restricted from '@/components/security/restricted.vue';
import notFound from '@/components/security/404.vue';
import scoringAnalytics from '@/components/user/scoringAnalytics/scoring.vue';
import groupsAdmin from '@/components/admin/groups/groupsAdmin.vue';
import userAdmin from '@/components/admin/users/userAdmin.vue';
import auditLog from '@/components/admin/Reports/auditLog.vue';
import purchaseLog from '@/components/admin/Reports/purchaseLog.vue';
import questionnaire from '@/components/user/questionnaire/questionnaire.vue';
import questionnaireDisclaimer from '@/components/user/questionnaire/Intro/disclaimer.vue';
import questionnaireIntroductory from '@/components/user/questionnaire/Intro/introductory.vue';
import A from '@/components/user/questionnaire/A/index.vue';
import questionnaireASummary from '@/components/user/questionnaire/A/summary.vue';
import questionnaireAIdera from '@/components/user/questionnaire/A/idera.vue';
import questionnaireALiens from '@/components/user/questionnaire/A/liens.vue';
import questionnaireADetentionRights from '@/components/user/questionnaire/A/detentionRights.vue';
import questionnaireAComments from '@/components/user/questionnaire/A/comments.vue';
import B from '@/components/user/questionnaire/B/index.vue';
import questionnaireBForm from '@/components/user/questionnaire/B/form.vue';
import E from '@/components/user/questionnaire/E/index.vue';
import questionnaireE0 from '@/components/user/questionnaire/E/protectionismA.vue';
import questionnaireE1 from '@/components/user/questionnaire/E/protectionismB.vue';
import questionnaireE2 from '@/components/user/questionnaire/E/protectionismC.vue';
import questionnaireE3 from '@/components/user/questionnaire/E/protectionismD.vue';
import questionnaireE4 from '@/components/user/questionnaire/E/contractInterpretation.vue';
import questionnaireE5 from '@/components/user/questionnaire/E/enforceability.vue';
import questionnaireE6 from '@/components/user/questionnaire/E/reposessionNonBankruptcy.vue';
import questionnaireE7 from '@/components/user/questionnaire/E/reposessionBankruptcy.vue';
import complianceIndexList from '@/components/user/complianceIndex/indexList.vue';
import complianceIndexCountry from '@/components/user/complianceIndex/countryIndex.vue';
import complianceIndexMap from "@/components/user/complianceIndex/map.vue";
import enforceabilityIndexList from '@/components/user/enforceabilityIndex/index-list.vue';
import enforceabilityIndexCountry from '@/components/user/enforceabilityIndex/country-index.vue';
import enforceabilityIndexAbout from '@/components/user/enforceabilityIndex/about.vue';
import enforceabilityIndexMethodology from '@/components/user/enforceabilityIndex/methodology.vue';
import enforceabilityIndexHistorical from '@/components/user/enforceabilityIndex/historical.vue';
import acidDocuments from '@/components/user/acid-documents/index.vue';
import acidDocumentsAdmin from '@/components/admin/acid-documents/acidDocumentsAdmin.vue';
import documentsAdmin from "@/components/admin/documents/documentsAdmin.vue";
import manageQuestionnaires from "@/components/manageQuestionnaires/manageQuestionnaires.vue";
import contact from "@/components/user/contact.vue";
import checkout from "@/components/checkout/checkout.vue";
import about from "@/components/user/about/about.vue";
import faq from "@/components/user/about/faq.vue";
import methodology from "@/components/user/about/methodology.vue";
import terms from "@/components/user/about/terms.vue";
import privacyPolicy from "@/components/user/about/privacy-policy.vue";
import manageProducts from "@/components/admin/manageProducts.vue";
import periodManager from "@/components/admin/periodManager.vue";
import countryIndexNotes from "@/components/admin/countryIndexNotes.vue";
import thankyou from "@/components/checkout/thankyou.vue";
import purchaseHistory from "@/components/user/purchases/purchaseHistory.vue";
import newUser from "@/components/security/newUser.vue";
import myAccount from "@/components/user/myAccount.vue";
import purchasingAccess from "@/components/user/videos/purchasingAccess.vue";
import useTheIndex from "@/components/user/videos/useTheIndex.vue";
import loginFlow from "@/components/loginFlow.vue";
import notAgreed from "@/components/security/notAgreed.vue";
import RequestQueue from "@/components/admin/users/requestQueue.vue";
import sync from "@/components/sync.vue";
import paymentDetailsHub from "@/components/user/paymentDetails/hub.vue";
import subscriptionsAdmin from "@/components/admin/users/subscriptionsAdmin.vue";
import confirmEmail from "@/components/security/confirmEmail.vue";

import asu from "@/components/user/asu/asu.vue";
import pdfViewer from "@/components/user/pdf-view/generic.vue";
import pdfAcidGen from "@/components/user/pdf-view/gen-acid.vue";

import { raygun } from "@/services/raygun";
import ctcTemplate from '@/components/ctcTemplate.vue';
import UserTemplate from '@/components/userTemplate.vue';

Vue.use(VueRouter);

import role from "@/roles";

var matchType = {
  AND: 'and',
  OR: 'or'
}

let router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //{
    //  path: "/testhub",
    //  name: "testhub",
    //  component: paymentDetailsHub
    //},
    {
      path: "/user",
      name: "UserTemplate",
      component: UserTemplate,
      children: [
        {
          path: "flow",
          name: "loginFlow",
          component: loginFlow,
        },
        {
          path: "sync",
          name: "sync",
          component: sync
        },
        {
          path: "setPassword/:id/:token",
          name: "newUser",
          component: newUser,
          props: true
        },
        {
          path: 'manage',
          name: 'userAdmin',
          component: userAdmin,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard
            ],
            isGroupManager: true
          },
          props: true
        },
        {
          path: "requests",
          name: 'RequestQueue',
          component: RequestQueue,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: "subscriptions",
          name: 'SubscriptionsAdmin',
          component: subscriptionsAdmin,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: "account",
          name: "account",
          component: myAccount,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.AWGMemberACC,
              role.AWGMemberCTC,
              role.ACCFullAccess,
              role.ACCPresaleAccess,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          }
        }
      ]
    },
    {
      path: "/",
      name: "CTCTemplate",
      component: ctcTemplate,
      children: [
        {
          path: '/login',
          name: 'login',
          component: login,
        },

        {
          path: '/restricted',
          name: 'restricted',
          component: restricted,
        },
        {
          path: '/404',
          name: '404',
          component: notFound
        },
        {
          path: '/pdf/:source?',
          name: 'pdfViewer',
          component: pdfViewer,
          props: route => ({ source: route.query.file || route.params.source || '' })
        },
        {
          path: '/pdf-acid',
          name: 'pdfAcidGen',
          component: pdfAcidGen,
        },
        {
          path: '/contact/:type',
          name: 'contact',
          component: contact,
          props: true
        },
        {
          path: '/checkout/:productId',
          name: 'checkout',
          component: checkout,
          props: true
        },
        {
          path: '/thankyou',
          name: 'thankyou',
          component: thankyou,
          props: true
        },
        {
          path: '/forgotPassword',
          name: 'forgotPassword',
          component: forgotPassword
        },
        {
          path: '/resetPassword/:code',
          name: 'resetPassword',
          component: resetPassword,
          props: true
        },
        {
          path: '/questionnaire',
          component: questionnaire,
          children: [
            {
              path: 'participation', component: questionnaireDisclaimer,
              meta: {
                match: matchType.OR,
                roles: [
                  role.CountryRespondent,
                  role.Admin
                ]
              }
            },
            {
              path: 'consent', component: questionnaireIntroductory,
              meta: {
                match: matchType.OR,
                roles: [
                  role.CountryRespondent,
                  role.Admin
                ]
              }
            },
            {
              path: 'a',
              component: A,
              children: [
                {
                  path: '0', component: questionnaireASummary,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '1', component: questionnaireAIdera,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '2', component: questionnaireALiens,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '3', component: questionnaireADetentionRights,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '4', component: questionnaireAComments,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                }
              ]
            },
            {
              path: 'b',
              component: B,
              children: [
                {
                  path: '0', component: questionnaireBForm,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                }
              ]
            },
            {
              path: 'e',
              component: E,
              children: [
                {
                  path: '0', component: questionnaireE0,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '1', component: questionnaireE1,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '2', component: questionnaireE2,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '3', component: questionnaireE3,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '4', component: questionnaireE4,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '5', component: questionnaireE5,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '6', component: questionnaireE6,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                },
                {
                  path: '7', component: questionnaireE7,
                  meta: {
                    match: matchType.OR,
                    roles: [
                      role.CountryRespondent,
                      role.Admin
                    ]
                  }
                }
              ]
            }

          ]
        },
        {
          path: '/admin/products',
          name: 'manageProducts',
          component: manageProducts,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: '/admin/auditlog',
          name: 'auditLog',
          component: auditLog,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: '/admin/purchaseLog',
          name: 'purchaseLog',
          component: purchaseLog,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: '/historicalData',
          name: 'scoringAnalytics',
          component: scoringAnalytics,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.Enhanced,
              role.Standard,
              role.AWGMember
            ],
          }
        },
        {
          path: '/admin/groups',
          name: 'groupsAdmin',
          component: groupsAdmin,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: '/admin/country-index-notes',
          name: 'countryIndexNotes',
          component: countryIndexNotes,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: '/manage/questionnaires',
          name: 'manageQuestionnaires',
          component: manageQuestionnaires,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.CountryRespondent
            ]
          }
        },
        {
          path: '/documents',
          name: 'documentsAdmin',
          component: documentsAdmin,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard
            ]
          }
        },
        {
          path: '/admin/acid-documents',
          name: 'acidDocumentsAdmin',
          component: acidDocumentsAdmin,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin
            ]
          }
        },
        {
          path: "/confirmEmail/:email",
          name: "sendEmail",
          component: confirmEmail
        },
        {
          path: "/confirmEmail/:email/:code",
          name: "confirmEmail",
          component: confirmEmail
        },
        {
          path: "/index",
          name: "complianceIndex",
          component: complianceIndexList,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          }
        },
        {
          path: "/historicalData/map",
          name: "complianceIndexMap",
          component: complianceIndexMap
        },
        {
          path: "/index/:GroupId",
          name: "complianceIndexCountry",
          component: complianceIndexCountry,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          },
          props: true
        },
        {
          path: "/enforceabilityIndex",
          name: "enforceabilityIndex",
          component: enforceabilityIndexList,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          }
        },
        {
          path: "/enforceabilityIndex/about",
          name: "enforceabilityIndexAbout",
          component: enforceabilityIndexAbout
        },
        {
          path: "/enforceabilityIndex/methodology",
          name: "enforceabilityIndexMethodology",
          component: enforceabilityIndexMethodology
        },
        {
          path: "/enforceabilityIndex/historical",
          name: "enforceabilityIndexHistorical",
          component: enforceabilityIndexHistorical,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          }
        },
        {
          path: "/enforceabilityIndex/:GroupId",
          name: "enforceabilityIndexCountry",
          component: enforceabilityIndexCountry,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          },
          props: true
        },
        {
          path: "/acid-documents",
          name: "acidDocuments",
          component: acidDocuments,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard
            ]
          }
        },
        {
          path: '/awg-asu-assessment',
          name: 'asu',
          component: asu,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          },
        },
        {
          path: '/about',
          name: 'about',
          component: about
        },
        {
          path: '/about/faq',
          name: 'faq',
          component: faq
        },
        {
          path: '/about/methodology',
          name: 'methodology',
          component: methodology
        },
        {
          path: '/about/terms',
          name: 'terms',
          component: terms,
          props: {
            isPage: true
          }
        },
        {
          path: '/about/privacy-policy',
          name: 'privacyPolicy',
          component: privacyPolicy,
          props: {
            isPage: true
          }
        },
        {
          path: "/manage/periods",
          name: "periodManager",
          component: periodManager,
          meta: {
            match: matchType.AND,
            roles: [
              role.Admin,
            ]
          },
        },
        {
          path: "/history",
          name: "purchaseHistory",
          component: purchaseHistory,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.Enhanced,
              role.Standard,
              role.AWGMember,
              role.CountryViewer,
              role.CountryRespondent
            ]
          }
        },
        {
          path: "/agree",
          name: "notAgreed",
          component: notAgreed
        },

        {
          path: "/purchasingAccess",
          name: "purchasingAccess",
          component: purchasingAccess,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          }
        },
        {
          path: "/useTheIndex",
          name: "useTheIndex",
          component: useTheIndex,
          meta: {
            match: matchType.OR,
            roles: [
              role.Admin,
              role.AWGMember,
              role.CountryRespondent,
              role.CountryViewer,
              role.Enhanced,
              role.Standard,
              role.FreeAccess
            ]
          }
        },
        {
          path: '/test',
          name: 'testpage',
          component: Test,
        },
        {
          path: '*',
          name: 'catchAll',
          component: login
        }
      ]
    },
  ],
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            selector: to.hash
          });
        }, 1000);
      });
    } else {
      return { x: 0, y: 0 }
    }
  },
});


function isUsersDomain() {
  const host = window.location.host;
  const parts = host.split('.');

  return parts[0] == "localhost:8080" || parts[0] == "users" || parts[0] == "users-staging";
}

function isCTCDomain() {
  const host = window.location.host;
  const parts = host.split('.');

  return parts[0] == "localhost:8080" || parts[0] == "ctc-compliance-index" || parts[0] == "ctc-staging" || parts[0] == "indices";
}


var ctcRoles = [
  "b8523895-dbe8-11e9-bfb2-0a8acc259594",
  "e04dc3a9-dbe8-11e9-bfb2-0a8acc259594",
  "87dbeb69-a930-11eb-bdc7-0a14b8f4c1fd",
  "e6d12e47-dbe8-11e9-bfb2-0a8acc259594",
  "e9874e89-dbe8-11e9-bfb2-0a8acc259594",
  "f4a3f3aa-dbe8-11e9-bfb2-0a8acc259594",
  "f9f3b143-dbe8-11e9-bfb2-0a8acc259594",
  "d2196a6c-e3c0-11e9-bfb2-0a8acc259594",
  "fe72c186-1b99-11ea-bfb2-0a8acc259594",
  "fe72c405-1b99-11ea-bfb2-0a8acc259594",
  "fe72c47f-1b99-11ea-bfb2-0a8acc259594",
  "d37f4991-1798-11ea-bfb2-0a8acc259594",
];

var accRoles = [
  "8fd58f64-a930-11eb-bdc7-0a14b8f4c1fd",
  "783ef5f4-867f-11eb-bdc7-0a14b8f4c1fd",
  "eb68cbac-7d1e-11eb-969d-0a8acc259594"
];

function HasCTCRole(roles) {
  return ctcRoles.some(x => roles.some(y => x === y));
}

function HasCCRole(roles) {
  return accRoles.some(x => roles.some(y => x === y));
}


router.beforeEach((to, from, next) => {
  if (store.getters.bus === undefined) {
    store.dispatch('init', {
      context: router.app
    });
  }

  const usersPages = ['sync', 'loginFlow', 'newUser', 'userAdmin', 'RequestQueue', 'account', "SubscriptionsAdmin"];
  const ctcPages = ['acidDocuments']; // Pages that should be accessible on CTC domain

  if (to.name == 'sync' && !isUsersDomain()) {
    window.location.href = process.env.VUE_APP_UserUrl + to.path;
    return;
  }

  if (store.getters.isLoggedIn) {
    const freePages = ['about', 'faq', 'methodology', 'contact'];

    if (usersPages.some(p => p == to.name) && HasCCRole(store.getters.user.Roles) && !HasCTCRole(store.getters.user.Roles)) {
      next();
      return;
    } else if (usersPages.some(p => p != to.name) && HasCCRole(store.getters.user.Roles) && !HasCTCRole(store.getters.user.Roles)) {
      next({ name: "account" });
      return;
    }

    if (to.name != "notAgreed" && to.name != "loginFlow" && !freePages.some(x => to.name === x) && store.getters.user.MustAgreeCTC) {
      next({ name: "notAgreed" });
      return;
    }

    if (store.getters.bus.$ENV != "DEV") {

      if (usersPages.some(p => p == to.name) && !isUsersDomain()) {
        window.location.href = process.env.VUE_APP_UserUrl + to.path;
        return;
      }
      else if (usersPages.every(p => p != to.name) && ctcPages.every(p => p != to.name) && !isCTCDomain()) {
        window.location.href = process.env.VUE_APP_CTCUrl + to.path;
        return;
      }
    }
  }

  if (to.path.startsWith("/setPassword")) {
    var separations = to.path.split("/");
    if (separations.length > 4) {
      var path = to.path;
      var last = 0;
      for (var i = 0; i < 2; i++) {
        last = path.indexOf('/', last + 1);
      }
      var token = path.substring(last + 1);
      var newPath = path.substring(0, last);
      token = token.replace(/\//g, "%2F");
      window.location.href = newPath + '/' + token;
    }
  }

  if (to.path.startsWith("/questionnaire")) {
    if (from.path.includes("/manage/questionnaire") || from.path.startsWith("/questionnaire")) {
      next();
    }
    else {
      next({ name: "manageQuestionnaires" });
    };
  }

  if (from.path.startsWith("/questionnaire")) {
    if (to.path.startsWith("/questionnaire") || to.path == "/manage/questionnaires") {
      next();
    }
    else {
      store.dispatch('setQuestionnaire', {});
      next();
    };
  }

  if (to.matched.some(record => record.meta.roles)) {
    if (store.getters.isLoggedIn) {
      if (to.meta.isGroupManager) {
        if (store.getters.user.IsGroupManager || store.getters.user.IsAdmin) {
          store.getters.bus.$emit('view-changed');
          next();
        } else {
          store.getters.bus.$emit('view-changed');
          next({ name: 'restricted' });
        }
      }
      else if (to.meta.match == matchType.AND) {
        if (to.meta.roles.every(role => store.getters.user.Roles && store.getters.user.Roles.indexOf(role) > -1)) {
          store.getters.bus.$emit('view-changed');
          next();
        }
        else {
          store.getters.bus.$emit('view-changed');
          next({ name: 'restricted' });
        }
      }
      else if (to.meta.match == matchType.OR) {
        if (to.meta.roles.some(role => store.getters.user.Roles && store.getters.user.Roles.indexOf(role) > -1)) {
          store.getters.bus.$emit('view-changed');
          next();
        }
        else {
          store.getters.bus.$emit('view-changed');
          next({ name: 'restricted' });
        }
      }
    } else {
      const freePages = ["sendEmail", "confirmEmail"];
      if (!freePages.some(p => p === to.name)) {
        store.getters.bus.$emit('view-changed');
        next({ name: 'login' });
      }
    }
  }
  else if (to.matched.length == 0) {
    store.getters.bus.$emit('view-changed');
    next({ name: '404' });
  }
  else {
    store.getters.bus.$emit('view-changed');
    next();
  }
})



router.afterEach((to, from) => {
  var self = router.app;
  //@ts-ignore
  if (self.$login) {
    //@ts-ignore
    self.$login.users();
    //@ts-ignore
    self.$login.ctc();
    //@ts-ignore
    self.$login.acc();
  }

  raygun('trackEvent', {
    type: 'pageView',
    path: to.path
  });
});

export default router;
